import _ from 'lodash';
// @ts-expect-error implicit any import
import getUtf8ByteLength from 'utf8-byte-length';

function byteLength(str: any) {
  // chunkArrayByLength initially used TextEncode to determine the length. TextEncode would
  // coerce values to strings (e.g. null would become "null") so concatenating '' mimics
  // that behavior.
  return getUtf8ByteLength(str + '');
}

export function chunkArrayByLength(arr: any[], maxChunkLength = 1400, chunkByBytes = true) {
  const chunkFn = chunkByBytes ? byteLength : _.size;

  const res: any[] = [];
  let currentChunk: any[] = [];
  let currentChunkLength = 0;
  _.forEach(arr, (elt) => {
    currentChunk.push(elt);
    currentChunkLength += chunkFn(elt);
    if (currentChunkLength >= maxChunkLength) {
      res.push(currentChunk);
      currentChunk = [];
      currentChunkLength = 0;
    }
  });
  if (currentChunkLength !== 0) {
    res.push(currentChunk);
  }
  return res;
}
